import HistoryItem from "entities/HistoryItem";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { TransactionsApi } from "./api";
import { ITransaction } from "./api/models";
import s from "./style.module.scss";

const HistoryList: React.FC = () => {
  const { user_info, auth_key } = useAppSelector(userSelect);

  const [items, setItems] = useState<ITransaction[]>([]);
  const [page, setPage] = useState(0);
  const [fetching, setFetching] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);

    return () => document.removeEventListener("scroll", handleScroll);
  });

  useEffect(() => {
    if (auth_key && user_info) {
      setIsLastPage(false);
      fetchTransactions();
    }
  }, [auth_key, user_info]);

  useEffect(() => {
    if (fetching) {
      fetchTransactions();
    }
  }, [fetching]);

  const fetchTransactions = () => {
    if (auth_key && user_info) {
      TransactionsApi({
        auth_key,
        user_id: user_info.id,
        page,
      })
        .then((res) => {
          console.log(res);
          if (res.length === 0) setIsLastPage(true);
          setItems([...items, ...res]);
          setPage((prev) => prev + 1);
        })
        .finally(() => setFetching(false));
    }
  };

  const handleScroll = (e: any) => {
    if (
      e.target.documentElement.scrollHeight -
        (e.target.documentElement.scrollTop + window.innerHeight) <
        100 &&
      !isLastPage
    ) {
      setFetching(true);
    }
  };
  return (
    <ul className={s.transactions}>
      {fetching ? (
        <li className={s.title}>Загрузка...</li>
      ) : items.length > 0 ? (
        items.map((item, key) => <HistoryItem {...item} key={key} />)
      ) : (
        <li className={s.title}>Транзакций нет</li>
      )}
    </ul>
  );
};

export default HistoryList;
